module.exports = __webpack_public_path__ + "static/media/wifi.4d24b722.svg";